 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTPREFACE from '@/components/Text/preface'
 import TEXTCHAPTER01 from '@/components/Text/chapter01'
 import TEXTCHAPTER02 from '@/components/Text/chapter02'
 import TEXTCHAPTER03 from '@/components/Text/chapter03'
 import TEXTCHAPTER04 from '@/components/Text/chapter04'
 import TEXTCHAPTER05 from '@/components/Text/chapter05'
 import TEXTCHAPTER06 from '@/components/Text/chapter06'
 import TEXTCHAPTER07 from '@/components/Text/chapter07'
 import TEXTCHAPTER08 from '@/components/Text/chapter08'
 import TEXTPHOTOS from '@/components/Text/photos'
 import TEXTCHAPTER09 from '@/components/Text/chapter09'
 import TEXTCHAPTER10 from '@/components/Text/chapter10'
 import TEXTCHAPTER11 from '@/components/Text/chapter11'
 import TEXTCHAPTER12 from '@/components/Text/chapter12'
 import TEXTCHAPTER13 from '@/components/Text/chapter13'
 import TEXTAFTERWORD from '@/components/Text/afterword'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTBIBLIOGRAPHY from '@/components/Text/bibliography'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/acknowledgments'
 import TEXTINDEX from '@/components/Text/index'
 import TEXTBCOVER from '@/components/Text/bcover'
 import TEXTDIS from '@/components/Text/dis'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/preface",
 			"name" : "Text/preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/chapter01",
 			"name" : "Text/chapter01",
 			"component" : TEXTCHAPTER01
 		},
 		{
 			"path" : "/Text/chapter02",
 			"name" : "Text/chapter02",
 			"component" : TEXTCHAPTER02
 		},
 		{
 			"path" : "/Text/chapter03",
 			"name" : "Text/chapter03",
 			"component" : TEXTCHAPTER03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js